export const FILTER_BY_CATEGORY = "blogFilter/Category";
export const FILTER_BY_AUTHOR = "blogFilter/Author";
export const FILTER_BY_TITLE = "blogFilter/Title";
export const FILTER_BY_READ = "blogFilter/Read";
export const FILTER_BY_SEARCH = "blogFilter/Search";
export const FILTER_CLEAR = "blogFilter/Clear";
